import React from 'react';
import { useTranslation } from 'react-i18next';
import { CallState } from '../../types';
import styles from './CallCard.module.css';

interface CallIncomingActionsProps {
  callState: CallState;
  isLoading: string | null;
  onAccept: () => void;
  onReject: () => void;
}

export function CallIncomingActions({
  callState,
  isLoading,
  onAccept,
  onReject,
}: CallIncomingActionsProps) {
  const { t } = useTranslation();

  return (
    <div className={styles.actionButtons}>
      {callState.isAutoAccept ? (
        <div className={styles.autoAcceptStatus}>
          <svg
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            className={styles.connectingIcon}
          >
            <path d="M22 16.92v3a2 2 0 01-2.18 2 19.79 19.79 0 01-8.63-3.07 19.5 19.5 0 01-6-6 19.79 19.79 0 01-3.07-8.67A2 2 0 014.11 2h3a2 2 0 012 1.72 12.84 12.84 0 00.7 2.81 2 2 0 01-.45 2.11L8.09 9.91a16 16 0 006 6l1.27-1.27a2 2 0 012.11-.45 12.84 12.84 0 002.81.7A2 2 0 0122 16.92z" />
          </svg>
          {t('call:status.autoConnecting')}
        </div>
      ) : (
        <>
          <button
            className={`${styles.actionBtn} ${styles.btnAccept}`}
            onClick={onAccept}
            disabled={isLoading !== null || !callState.contactId}
          >
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <path d="M22 16.92v3a2 2 0 01-2.18 2 19.79 19.79 0 01-8.63-3.07 19.5 19.5 0 01-6-6 19.79 19.79 0 01-3.07-8.67A2 2 0 014.11 2h3a2 2 0 012 1.72 12.84 12.84 0 00.7 2.81 2 2 0 01-.45 2.11L8.09 9.91a16 16 0 006 6l1.27-1.27a2 2 0 012.11-.45 12.84 12.84 0 002.81.7A2 2 0 0122 16.92z" />
            </svg>
            {t('call:actions.accept')}
          </button>
          <button
            className={`${styles.actionBtn} ${styles.btnReject}`}
            onClick={onReject}
            disabled={isLoading !== null || !callState.contactId}
          >
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <path d="M10.68 13.31a16 16 0 006 6l1.27-1.27a2 2 0 012.11-.45 12.84 12.84 0 002.81.7A2 2 0 0122 16.92V20a2 2 0 01-2.18 2 19.79 19.79 0 01-8.63-3.07M1 1l22 22M16.56 2a19.79 19.79 0 01.56 3.67A2 2 0 0115.32 8l-1.27 1.27" />
              <path d="M4.22 4.22A19.79 19.79 0 002 19.82 2 2 0 004.11 22h3a2 2 0 002-1.72" />
            </svg>
            {t('call:actions.reject')}
          </button>
        </>
      )}
    </div>
  );
}

export default CallIncomingActions;
